// ════════════════════════════════════════════════════════════════════
// Drapeaux d'offre du visiteur (posés par main.jsx avant React, hydratés
// par sub-info au login). Source de vérité pour la COPY : la mention
// « essai 7 jours » ne doit s'afficher que si le checkout offrira vraiment
// un essai. Cas Adrian (06/08) : la page promettait l'essai, le paywall
// membre le refusait → « soucis de redirection », prospect perdu.
// ════════════════════════════════════════════════════════════════════

export function showsTrialUx() {
  try {
    if (localStorage.getItem('studio_offer_arm') === 'C') return false
    if (localStorage.getItem('studio_deal_offer') === '1') return false
    if (localStorage.getItem('studio_member_offer') === '1') return false
    return true
  } catch { return true }
}
